import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./AppBanner.css";

// Mobil uygulama içinden mi açıldığını kontrol eden fonksiyon
const isRunningInApp = () => {
  // 1. Standalone mode kontrolü (PWA veya native WebView)
  const isStandalone =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;

  // 2. URL parametresi kontrolü (uygulama içinden açıldıysa ?app=true gibi)
  const urlParams = new URLSearchParams(window.location.search);
  const hasAppParam =
    urlParams.get("app") === "true" || urlParams.get("source") === "app";

  // 3. localStorage kontrolü (bir kez uygulama içinden girildiyse hatırla)
  const isFromApp = localStorage.getItem("isFromMobileApp") === "true";

  // 4. User Agent kontrolü (özel uygulama user agent'ı varsa)
  const userAgent = navigator.userAgent || "";
  const isMukemelApp = userAgent.includes("MukemelApp");

  // 5. Expo/React Native WebView kontrolü
  const isExpoApp =
    userAgent.includes("Expo") ||
    userAgent.includes("ExpoGo") ||
    window.ReactNativeWebView !== undefined;

  // 6. iOS App Store'dan indirilen uygulama kontrolü (WKWebView)
  const isWKWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
    userAgent,
  );

  // 7. Android WebView kontrolü
  const isAndroidWebView =
    /wv|WebView/i.test(userAgent) && /Android/i.test(userAgent);

  // 8. window.isNativeApp global flag kontrolü (native app tarafından set edilebilir)
  const hasNativeFlag = window.isNativeApp === true;

  // Eğer URL'de app parametresi varsa, localStorage'a kaydet
  if (hasAppParam) {
    localStorage.setItem("isFromMobileApp", "true");
  }

  // Expo veya WebView içindeyse localStorage'a kaydet
  if (isExpoApp || isWKWebView || isAndroidWebView || hasNativeFlag) {
    localStorage.setItem("isFromMobileApp", "true");
  }

  return (
    isStandalone ||
    hasAppParam ||
    isFromApp ||
    isMukemelApp ||
    isExpoApp ||
    isWKWebView ||
    isAndroidWebView ||
    hasNativeFlag
  );
};

const AppBanner = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Mobil uygulama içinden açıldıysa banner'ı gösterme
    if (isRunningInApp()) {
      return;
    }

    // localStorage'dan banner durumunu kontrol et
    const bannerDismissed = localStorage.getItem("appBannerDismissed");

    // Eğer daha önce kapatılmamışsa göster
    if (!bannerDismissed) {
      // Sayfa yüklendikten 1 saniye sonra göster (daha iyi UX)
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    // Kullanıcı kapattığında localStorage'a kaydet
    localStorage.setItem("appBannerDismissed", "true");
  };

  const handleOpenApp = () => {
    // Uygulama linkine yönlendir ve banner'ı kapat
    localStorage.setItem("appBannerDismissed", "true");

    // iOS için App Store linki
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isAndroid = /Android/.test(navigator.userAgent);

    if (isIOS) {
      window.location.href =
        "https://apps.apple.com/us/app/mukemel/id6753164005";
    } else if (isAndroid) {
      // Android için Google Play linki (yakında)
      window.location.href = "/application";
    } else {
      // Masaüstü için uygulama sayfasına yönlendir
      window.location.href =
        "https://apps.apple.com/us/app/mukemel/id6753164005";
    }
  };

  if (!isVisible) return null;

  return (
    <div className="app-banner-overlay">
      <div className="app-banner-container">
        <button
          className="app-banner-close"
          onClick={handleClose}
          aria-label={t("common.close") || "Kapat"}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>

        <div className="app-banner-content">
          <div className="app-banner-text">
            <span>
              {t("appBanner.title") || "Mobil Uygulamamızı Denediniz mi?"}
            </span>
          </div>

          <button className="app-banner-button" onClick={handleOpenApp}>
            {t("appBanner.openApp") || "Mobil uygulamada aç"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppBanner;
